<script>
    import { createEventDispatcher } from "svelte";

    export let results;
    export let resultType; // Studiengang/Ausbildung

    let dispatch = createEventDispatcher();
</script>

<div class="border border-secondary border-collapse rounded-lg">
    <table id={resultType} class="border-hidden table-fixed w-[100%] text-secondary-text">
        <thead class="text-xs text-gray-600 uppercase font-semibold">
            <th class="border border-secondary p-1 w-[3%]">#</th>
            <th class="border border-secondary p-1 w-[80%]">{resultType}</th>
            <th class="border border-secondary p-1">Übereinstimmung</th>
        </thead>
        {#each results as result, index}
            <tr class="{index % 2 === 0 ? 'bg-accent-light' : 'bg-accent-very-light'} hover:bg-accent-hover cursor-pointer" on:click={() => dispatch('openPopup', result)}>
                <td class="border border-secondary p-1 text-center font-semibold">{index + 1}</td>
                <td class="border border-secondary p-1">{result.job}</td>
                <td class="border border-secondary p-1">{(result.score * 100).toFixed(0)}%</td>
            </tr>
        {/each}
    </table>
</div>